import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'fo-plus-button',
  templateUrl: './plus-button.component.html',
  styleUrl: './plus-button.component.scss',
  imports: [MatIconModule],
  host: {
    '[class.disabled]': 'disabled',
  },
})
export class PlusButtonComponent {
  @Input() disabled = false;
}
